import React from 'react';

export function newLineToBreak(input?: string | null) {
    if (!input) {
        return null;
    }
    return (
        <>
            {input.split('\n').map((item: string, i: number) => (
                <span key={i}>
                    {item}
                    <br />
                </span>
            ))}
        </>
    );
}
